import { Box, Flex, FlexProps } from '@chakra-ui/react';

import { formatTimeValue } from '~/hooks/use-countdown';

export type CountdownTimerProps = {
  containerProps?: FlexProps;
  days: number;
  hours: number;
  hoursOnly?: boolean;
  minutes: number;
  seconds: number;
};

export function CountdownTimer({ days, hours, minutes, seconds, containerProps, hoursOnly }: CountdownTimerProps) {
  return (
    <Flex alignItems='center' {...containerProps}>
      {!hoursOnly && <TimeBox label='day' value={formatTimeValue(days)} />}
      <TimeBox label='hrs' value={formatTimeValue(hours)} />
      <TimeBox label='min' value={formatTimeValue(minutes)} />
      <TimeBox label='sec' value={formatTimeValue(seconds)} />
    </Flex>
  );
}

function TimeBox({ value, label }: { value: string; label: string }) {
  return (
    <Flex
      alignItems='center'
      flex='1'
      flexDir='column'
      minWidth='32px'
      position='relative'
      textAlign='center'
      _notLast={{
        '&::after': {
          content: "'|'",
          display: 'block',
          position: 'absolute',
          top: '50%',
          transform: 'translate(50%, -50%)',
          right: '0',
          opacity: '0.75',
          fontSize: '1rem',
          color: 'grey.300',
          fontWeight: '400',
        },
      }}
    >
      <Box
        fontFamily='condensed'
        fontSize='1.25rem'
        fontWeight='600'
        sx={{
          fontFeatureSettings: 'tnum',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </Box>
      <Box
        color='grey.300'
        fontFamily='condensed'
        fontSize='0.6875rem'
        fontWeight='500'
        letterSpacing='0.05em'
        lineHeight='1'
        textTransform='uppercase'
      >
        {label}
      </Box>
    </Flex>
  );
}
